@if (maintenanceService.maintenanceMessage()) {
<div class="app__maintenance">
  <img src="assets/images/core/tf2-logo.png" />
  <a class="app__maintenance--discord" [href]="DISCORD_LINK" target="_blank">
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/icons/socials/discord.svg"
    />
    Join our Discord
  </a>
  <p>{{ maintenanceService.maintenanceMessage() }}</p>
</div>
}@else {
<div class="app">
  <img
    class="app__background"
    src="assets/images/core/bg-effected.png"
    alt="background"
    loading="lazy"
  />
  <app-header class="header"></app-header>
  <app-chat
    [class.chat--open]="uiService.isShowChat()"
    class="chat"
  ></app-chat>

  <main class="main">
    <router-outlet />
  </main>
  <footer class="footer">
    <span class="footer__version">v{{ version }}</span>
  </footer>
</div>
}
